/**
 * Build binder section(s) from a Budget tool export (full backup JSON).
 * Used by Build your binder when user uploads a budget export file.
 * @param {object} data - Parsed budget export: { budget_info, calculations }
 * @returns {Array<{ name: string, content: string }>}
 */
export function budgetExportToSections(data) {
  const info = data?.budget_info || {};
  const calc = data?.calculations || {};
  const ef = calc.emergency_fund || {};
  const years = info.emergency_fund_target_years ?? 3;

  const content = `
<div class="section-content">
  <div class="section-title">Basic Information</div>
  <div class="item-row"><span class="label">Monthly Income (After Taxes):</span> $${Number(info.monthly_income ?? 0).toLocaleString()}</div>
  <div class="item-row"><span class="label">Family Members:</span> ${(info.family_members || []).length}</div>
  ${(info.family_members || []).map((m) => `<div class="item-row">${m.name} (Age ${m.age}) ${m.has_emergency_cash ? '— Has $500 emergency cash' : '— Needs $500 emergency cash'}</div>`).join('')}
  <div class="section-title">Emergency Fund</div>
  <div class="item-row"><span class="label">Target:</span> $${Number(ef.requiredAmount ?? 0).toLocaleString()}</div>
  <div class="item-row"><span class="label">Current:</span> $${Number(info.emergency_fund_current ?? 0).toLocaleString()}</div>
  <div class="item-row"><span class="label">Suggested Monthly:</span> $${Math.round(Number(ef.suggestedMonthlyContribution ?? 0))} (${years}-year plan)</div>
  <div class="section-title">Monthly Summary</div>
  <div class="item-row"><span class="label">Total Expenses:</span> $${Number(calc.total_expenses ?? 0).toLocaleString()}</div>
  <div class="item-row"><span class="label">Free Cash Flow:</span> $${Number(calc.free_cash_flow ?? 0).toLocaleString()}</div>
  <div class="item-row"><span class="label">Available for Debt:</span> $${Number(calc.available_for_debt ?? 0).toLocaleString()}</div>
</div>`;

  return [{ name: 'Budget Summary', content }];
}
